console.log('js/trackSuite.js -> v0.1.1');

var trackSuite = (() => {
	/* Data object for the scroll position tracking */
	const scrollData = {
		sectionsPositions: [],
		sectionsIndex: 1,
		windowCenter: window.innerHeight / 2
	};

	// general debounce function that is being used on scroll tracking
	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	/**
	 * Functions that are being run
	 */

	function trackScrolledSections() {
		if (scrollData.sectionsPositions.length > 0 && (window.pageYOffset + scrollData.windowCenter) > scrollData.sectionsPositions[0].pos) {
			gae('listing-scroll-position', `${scrollData.sectionsIndex}-${scrollData.sectionsPositions[0].id}`);
			scrollData.sectionsPositions.splice(0, 1);
			scrollData.sectionsIndex++;
		}
	}
	// get the selected text value
	function trackSelectedText() {
		let text = window.getSelection().toString();

		if (text.length > 2 && text.length < 100) {
			gae('text-highlight', text.trim());
		}
	}


	/**
	 * Setup checking
	 */

	// check for the different reasons why
	function initTrackScroll() {
		const sections = document.querySelectorAll('.trip-track');
		const footerPressLogo = document.querySelector('.press-logo-container');
    const giftcardPromotionBox = document.querySelector('#giftcard-promotion-box');
    const giftcardPromotionSection = document.querySelector('#giftcard-promotion-section');

    let giftcardPromotionBoxViewed = false;
    let giftcardPromotionSectionViewed = false;
		let footerPressViewed = false;

		const footerSectionNewsletterSignup = document.querySelector('.sector-newsletter-container');
		var footerSectionNewsletterSignupViewed = false;

		if (sections.length == 0 && footerPressLogo == null && footerSectionNewsletterSignup == null) {
			return false;
		}

		for (var i = 0; i < sections.length; i++) {
			let getPos = sections[i].getBoundingClientRect();

			let s = {
				'id': sections[i].dataset.sectionId,
				'pos': getPos.y
			}

			scrollData.sectionsPositions.push(s);
		}

		if (sections.length > 0) {
			window.addEventListener('scroll', debounce(trackScrolledSections, 25));
		}

		if (footerPressLogo != null) {
			window.addEventListener('scroll', debounce(function() {
				if((footerPressLogo.offsetTop < (window.pageYOffset + scrollData.windowCenter)) && (!footerPressViewed)) {
					gae('footer-press-section', 'Viewed');
					footerPressViewed = true;
				}
			}, 25));
		}

    if (giftcardPromotionBox != null) {
			window.addEventListener('scroll', debounce(function() {
				if((giftcardPromotionBox.offsetTop < (window.pageYOffset + scrollData.windowCenter)) && (!giftcardPromotionBoxViewed)) {
					gae('giftcard-promotion-box', 'Viewed');
					giftcardPromotionBoxViewed = true;
				}
			}, 25));
    }

    if (giftcardPromotionSection != null) {
			window.addEventListener('scroll', debounce(function() {
				if((giftcardPromotionSection.offsetTop < (window.pageYOffset + scrollData.windowCenter)) && (!giftcardPromotionSectionViewed)) {
					gae('giftcard-promotion-section', 'Viewed');
					giftcardPromotionSectionViewed = true;
				}
			}, 25));
    }

		if (footerSectionNewsletterSignup != null) {
			window.addEventListener('scroll', debounce(function() {
				if((footerSectionNewsletterSignup.offsetTop < (window.pageYOffset + scrollData.windowCenter)) && (!footerPressViewed)) {
					gae('newsletter','newsletter_inview');
					footerSectionNewsletterSignupViewed = true;
				}
			}, 25));
		}


	}

	function initTrackSelectedText() {
		document.addEventListener('mouseup', trackSelectedText);
	}

  document.addEventListener('DOMContentLoaded', function() {
    initTrackScroll();
    initTrackSelectedText();
  });
})();
